export const fields = {
  firstName: "نام",
  lastName: "نام خانوادگی",
  phoneNumber: "شماره موبایل",
  email: "ایمیل",
  purchaserName: "نام رزرو کننده",
  purchaserFamily: "نام خانوادگی رزرو کننده",
  purchaserMobileNumber: "شماره موبایل رزرو کننده",
  purchaserEmail: "ایمیل رزرو کننده",
  supervisorName: "نام سرپرست",
  supervisorFamily: "نام خانوادگی سرپرست",
  supervisorEmail: "ایمیل سرپرست",
  supervisorMobileNumber: "شماره موبایل سرپرست",
  isPurchaserSupervisor: "سرپرست مسافران خودم هستم",
  requisition: "درخواست از هتل",
  companyName: "نام سازمان یا شرکت",
  agencyName: "نام آژانس",
  passengerInfo: {
    mainPassengerName: "نام مسافر",
    mainPassengerFamily: "نام خانوادگی مسافر",
    mainPassengerNationality: "ملیت مسافر",
    mainPassengerNationalCode: "کدملی مسافر",
    mainPassengerMobileNumber: "شماره موبایل مسافر",
    mainPassengerGender: "جنسیت",
    extraBedCount: "تعداد تخت اضافه",
    childCount: "تعداد کودک",
    infantCount: "تعداد نوزاد"
  },
  otherPassengersInfo: {
    mainPassengerName: "نام مسافر",
    mainPassengerFamily: "نام خانوادگی مسافر",
    mainPassengerGender: "جنسیت"
  },
  hasFreeTransfer: "ترانسفر رایگان",
  freeTransferNumber: "شماره {type}",
  freeTransferDeparture: "شهر مبدا {type}",
  freeTransferMobileNumber: "شماره موبایل",
  freeTransferPassengerCount: "تعداد نفرات",
  buyer: {
    mobileNumber: "شماره موبایل رزرو کننده",
    firstName: "نام رزرو کننده",
    lastName: "نام خانوادگی رزرو کننده",
    email: "ایمیل رزرو کننده"
  },
  roomGuest: {
    passengers: {
      firstName: "نام مسافر",
      lastName: "نام خانوادگی مسافر",
      gender: "جنسیت مسافر",
      birthDate: "تاریخ تولد مسافر",
      expireDate: "تاریخ انقضای گذرنامه",
      passportCode: "شماره گذرنامه",
      nationality: "ملیت",
      documentType: "ملیت مسافر",
      documentId: "کدملی مسافر"
    }
  },
  snapp_pay_title: "امکان رزرو ۴قسطه بدون ضامن، چک و سفته",
  snapp_pay_gateway: "با انتخاب درگاه اسنپ‌پی هنگام پرداخت",
  more_details: "جزییات بیشتر"
};
